import { useRef } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import { workCases } from '@/mocks/work';
import useLightReveal from '@/hooks/useLightReveal';
import WorkCard from './components/WorkCard';

export default function WorkPage() {
  const ref = useRef<HTMLElement>(null);
  useLightReveal(ref, 'work');

  return (
    <>
      <title>Work | AUREN Management Consulting — Strategy &amp; Change</title>
      <meta name="description" content="Illustrative AUREN engagements across growth strategy, operating models, leadership alignment, positioning, service experience and portfolio priorities." />
      <Navbar />
      <main ref={ref} className="bg-background-50 pt-14">
        <section className="wrap pt-20 md:pt-32 pb-12 md:pb-16">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-8 items-end">
            <div className="lg:col-span-8" data-fade>
              <span className="label-xs text-foreground-600">Selected work / Strategy &amp; Change</span>
              <h1 className="font-heading font-light uppercase leading-[0.92] tracking-[0.02em] text-foreground-950 mt-6 text-[clamp(44px,7vw,100px)]">Work.</h1>
            </div>
            <p className="lg:col-span-4 font-heading font-light uppercase tracking-[0.04em] leading-[1.35] text-[17px] md:text-[20px] text-foreground-950 max-w-[360px] lg:pb-3" data-fade>
              Different challenges.<br />Clearer directions.
            </p>
          </div>
        </section>

        <section className="wrap pb-24 md:pb-32" aria-label="Case studies">
          <div className="flex items-center justify-between border-t border-foreground-950/15 pt-4 mb-10 md:mb-14">
            <span className="label-xs text-foreground-600">Illustrative engagement</span>
            <span className="label-xs text-foreground-600">01&mdash;{String(workCases.length).padStart(2, '0')}</span>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-7 lg:gap-x-8 gap-y-14 md:gap-y-20">
            {workCases.map((c, i) => (
              <WorkCard key={c.slug} slug={c.slug} category={c.category} title={c.title} brief={c.brief} cover={c.cover} eager={i < 3} />
            ))}
          </div>
        </section>

        <section className="border-t border-foreground-950/15">
          <div className="wrap py-16 md:py-24 flex flex-col md:flex-row md:items-center justify-between gap-8" data-fade>
            <p className="font-heading font-light uppercase tracking-[0.02em] leading-[1.05] text-foreground-950 text-[clamp(28px,4vw,52px)]">Start a conversation.</p>
            <Link to={{ pathname: '/', hash: '#contact' }} className="group inline-flex items-center gap-4 label-xs text-foreground-950 cursor-pointer whitespace-nowrap">
              Get in touch<span className="circle-arrow inv-dark"><i className="ri-arrow-right-line" /></span>
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}